import { useCallback, useContext, useState } from "react";
import { AuthContext } from "../AuthContext";
import { ParentContext } from "../ParentContext";

export const _authProjectName = null

export const useAuth = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const [authUid, setAuthUid] = useState()
  const [authData, setAuthData] = useState()
  const [invalidUser, setInvalidUser] = useState()
  const [updating, setUpdating] = useState()
  const [confirmation, setConfirmation] = useState()

  const handleSaveResponse = (response) => {
    const { data } = response ?? {}
    const { success, result } = data ?? {}
    const { error } = result ?? {}
    const { errorInfo } = error ?? {}
    const { message } = errorInfo ? errorInfo : {}
    setUpdating(false)
    setConfirmation({
      title: success ? 'Updated' : message,
      success
    });
  }

  const cb_userAuth = (result) => {
    const { uid, customClaims } = result ?? {}
    console.log('result', result)
    if (uid) {
      const md = customClaims ? { ...result, ...customClaims } : result
      setAuthUid(uid)
      setAuthData(md)
    } else {
      setInvalidUser(true)
      // setAuthData({})
    }
    setUpdating(false)
  }

  const getAuth = useCallback(async (selectedAppUser) => {
    setUpdating(true)
    const cb_getAuth = (result) => {
      const { uid } = result ?? {}
      if (uid) {
        cb_userAuth(result)
      } else {
        fn_cls.getAuthByPhoneNumber(selectedAppUser, cb_userAuth)
      }
    }
    fn_cls.getAuthByEmail(selectedAppUser, cb_getAuth, _authProjectName, true)
  }, [])

  const ammendAuth = useCallback((authData) => {
    setAuthData(authData)
  }, [])

  const updateAuth = useCallback(async (authUid, authData) => {
    setUpdating(true)
    const _authData = { pathViews }
    Object.keys(authData).forEach(key => {
      switch (key) {
        case 'newPassword':
        case 'confirmNewPassword':
          break;
        case 'authLevel':
        case 'disabled':
        case 'displayName':
        case 'email':
        case 'phoneNumber':
        case 'profileLevel':
          if (authData[key]) {
            _authData[key] = authData[key]
          }
          break;
        case 'clientAuthLevel':
          if (authData[key]) {
            _authData[key] = authData[key]
          } else {
            delete _authData[key]
          }
          break;
        default:
      }
    })
    if (authData.newPassword) {
      if (authData.newPassword === authData.confirmNewPassword) {
        _authData.password = authData.newPassword
      }
    }
    setUpdating(false)
    fn_cls.updateAuthByUid(authUid, _authData, handleSaveResponse, _authProjectName)
  }, [])

  const deleteAuth = useCallback(async (authUid) => {
    setUpdating(true)
    if (authUid) { fn_cls.deleteAuthByUid(authUid, null, handleSaveResponse) }
  }, [])

  const clearConfirmation = useCallback(async () => {
    if (confirmation) {
      const timer = setTimeout(() => {
        setConfirmation()
      }, confirmation.success === true ? 3000 : 5000);
      return () => {
        clearTimeout(timer)
      };
    }
  }, [])

  return { getAuth, updateAuth, deleteAuth, ammendAuth, clearConfirmation, authUid, authData, invalidUser, updating, confirmation };
};
